import { useState } from 'react'
import { DayPickerSingleDateController } from 'react-dates'
import moment, { Moment } from 'moment'
import 'moment/locale/pl'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { Wrapper } from 'components/shared/Calendar/styles'
import CustomButton from 'components/shared/Calendar/components/CustomButton'
import CustomMonth from 'components/shared/Calendar/components/CustomMonth'
import { GetCardCalendarPresenter } from 'store/api-slice/hooks'
import Day from 'components/shared/Calendar/components/Day'

interface SimpleCalendarProps {
    mode: 'single' | 'range' | 'buses' | 'accommodation' | 'unlimitedCard'
    handleDatesChosen: (dates: Moment[]) => void
    datesInfo: GetCardCalendarPresenter | null
    isLimitedRange: boolean
    rangeLimit?: number
    isDisabled: boolean
    date?: Moment | null
    testIdPrefix?: string
}

const SimpleCalendar = ({
    mode,
    datesInfo,
    isDisabled,
    date,
    testIdPrefix,
}: SimpleCalendarProps) => {
    const [dateDefiningMonth, setDateDefiningMonth] = useState(
        moment(datesInfo?.from)
    )

    const unlimitedEntryType = (day: Moment) => {
        if (!datesInfo) return

        if (datesInfo.secondaryDays?.includes(day.format('YYYY-MM-DD'))) {
            if (datesInfo.excluded?.includes(day.format('YYYY-MM-DD')))
                return 'closed'
            return 'unlimitedPlus'
        } else if (datesInfo.excluded?.includes(day.format('YYYY-MM-DD'))) {
            return 'closed'
        } else {
            return
        }
    }

    return (
        <Wrapper>
            <DayPickerSingleDateController
                date={date || null}
                onDateChange={() => null}
                focused={false}
                onFocusChange={() => null}
                renderDayContents={(day) => (
                    <Day
                        isHighlighted={false}
                        dayToRender={day}
                        unlimitedEntryType={
                            mode === 'unlimitedCard'
                                ? unlimitedEntryType(day)
                                : ''
                        }
                        testId={`${
                            testIdPrefix ? `${testIdPrefix}-` : ''
                        }calendar-day-${day.format('DD-MM')}`}
                    />
                )}
                isOutsideRange={(day) =>
                    day.isBefore(moment(datesInfo?.from)) ||
                    day.isAfter(moment(datesInfo?.to)) ||
                    isDisabled
                }
                renderNavNextButton={({ onClick }) => (
                    <CustomButton
                        isDisabled={
                            dateDefiningMonth.format('MMYYYY') ===
                                moment(datesInfo?.to).format('MMYYYY') ||
                            isDisabled
                        }
                        onClick={onClick}
                        direction="-next"
                        testId={`${
                            testIdPrefix ? `${testIdPrefix}-` : ''
                        }calendar-button-next-month`}
                    />
                )}
                renderNavPrevButton={({ onClick }) => (
                    <CustomButton
                        isDisabled={
                            dateDefiningMonth.format('MMYYYY') ===
                                moment(datesInfo?.from).format('MMYYYY') ||
                            isDisabled
                        }
                        onClick={onClick}
                        direction="-prev"
                        testId={`${
                            testIdPrefix ? `${testIdPrefix}-` : ''
                        }calendar-button-next-month`}
                    />
                )}
                firstDayOfWeek={1}
                daySize={45}
                hideKeyboardShortcutsPanel={true}
                enableOutsideDays={true}
                noBorder={true}
                weekDayFormat="ddd"
                isFocused={true}
                initialVisibleMonth={() => {
                    if (date) {
                        setDateDefiningMonth(date)
                        return date
                    } else {
                        return moment(datesInfo?.from)
                    }
                }}
                onPrevMonthClick={setDateDefiningMonth}
                onNextMonthClick={setDateDefiningMonth}
                renderMonthElement={CustomMonth}
                transitionDuration={0}
            />
        </Wrapper>
    )
}

export default SimpleCalendar
